import Model from 'ln/model/Model';
import { Resolvable } from 'ln/components/Resolve';
import { StepTheme } from './StepTheme';
import { ChapterElement, Chapter } from 'components/chapter/Chapter';

export class StepByStep extends Model implements ChapterElement{

    public readonly chapter:Chapter;
    public readonly themes:StepTheme[];
    public readonly title:string;
    public showTheme:boolean;
    public selectedTheme:StepTheme;

    public constructor(json: object) {
        super({
            themes:[],
            title: '',
            showTheme: false,
            selectedTheme: null,
            chapter:null,
            ...json
        });

        if (this.themes.length) {
            this.themes.forEach( ( theme, index, themes ) => { 
                theme.stepbystep = this;
                theme.index = index + 1;
            });
        }
    }

    public getViewName(): string {
        return 'StepByStep';
    }

    public showThemeDetails( theme:StepTheme ){
        this.selectedTheme = theme;
        this.showTheme = true;
        this.chapter.hideCloseButton = true;

    }

    public canShowNext(){
        return this.themes.indexOf( this.selectedTheme ) != this.themes.length - 1;
    }

    public nextTheme(){
        if( this.canShowNext() ){
            let index = this.themes.indexOf( this.selectedTheme );
            this.showThemeDetails( this.themes[ index + 1] );
        }
    }

    public closeThemeDetails(){
        this.showTheme = false;
        this.chapter.hideCloseButton = false;
    }
}